import { inject, Pipe, PipeTransform } from '@angular/core';
import { VarService } from '../services/var.service';

const BUILTIN_KEYS: Record<string, string> = {
  roepnaam: 'Roepnaam — in te stellen bij Client instellingen',
};

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}

@Pipe({
  name: 'highlightVariables',
  pure: false,
})
export class HighlightVariablesPipe implements PipeTransform {
  private readonly _varService = inject(VarService);

  transform(value: string): string {
    if (!value) {
      return '';
    }

    const varMap = this._varService.varMap();

    return value.replace(/\[([^\]]+)\]/g, (match, key) => {
      // 1. Builtin vars (roepnaam)
      if (key in BUILTIN_KEYS) {
        const tooltip = escapeHtml(BUILTIN_KEYS[key]);
        return `<span class="var-highlight var-highlight--builtin" title="${tooltip}">${match}</span>`;
      }

      const varInfo = varMap.get(key);
      if (!varInfo) {
        return match;
      }

      // 2. Soft-deleted vars
      if (varInfo.deleteAt) {
        const deleteDate = new Date(varInfo.deleteAt).toLocaleDateString('nl-NL', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
        const tooltip = escapeHtml(
          `Deze variabele wordt verwijderd op ${deleteDate}.\nWaarde na verwijdering: ${varInfo.value}`
        );
        return `<span class="var-highlight var-highlight--deleted" title="${tooltip}">${match}</span>`;
      }

      // 3. Active vars
      const parts = [`Waarde: ${varInfo.value}`];
      if (varInfo.description) {
        parts.push(varInfo.description);
      }
      const tooltip = escapeHtml(parts.join('\n'));
      return `<span class="var-highlight" title="${tooltip}">${match}</span>`;
    });
  }
}
